// El menú que abre la `@` en la caja del Agente — ADR-2026-09-21-la-arroba-menciona-los-
// adjuntos: lo que está enganchado, con miniatura, nombre y qué es. Misma anatomía que el
// menú de colores (`absolute bottom-full`, sin portal, `mousedown` apagado para que la caja
// no pierda el foco); el teclado lo maneja el textarea.

import { FileText, Film, Images, User } from 'lucide-react';
import type { OpcionDeMencion } from './mencionesDelChat';

const IconoSinMiniatura: React.FC<{ kind: OpcionDeMencion['kind'] }> = ({ kind }) => {
  const Icono = kind === 'model' ? User : kind === 'video' ? Film : kind === 'moodboard' ? Images : FileText;
  return (
    <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#F0F2F7] text-[#02062B]/[0.45]">
      <Icono className="h-4 w-4" aria-hidden="true" />
    </span>
  );
};

export const MenuDeMenciones: React.FC<{
  opciones: OpcionDeMencion[];
  activo: number;
  onActivar: (i: number) => void;
  onElegir: (opcion: OpcionDeMencion) => void;
}> = ({ opciones, activo, onActivar, onElegir }) => (
  <div
    role="listbox"
    aria-label="Adjuntos para mencionar"
    className="absolute bottom-full left-3 z-[56] mb-2 w-[300px] rounded-2xl border border-[#02062B]/[0.06] bg-white p-1.5 shadow-xl animate-fade-in"
    onMouseDown={(e) => e.preventDefault()}
  >
    <p className="px-3 pb-1 pt-1.5 text-[11px] font-medium uppercase tracking-wide text-[#02062B]/[0.45]">Mencionar un adjunto</p>
    <div className="max-h-[288px] overflow-y-auto">
      {opciones.map((o, i) => (
        <button
          key={o.id}
          type="button"
          role="option"
          aria-selected={i === activo}
          onMouseEnter={() => onActivar(i)}
          onClick={() => onElegir(o)}
          className={`flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left transition-colors ${i === activo ? 'bg-[#F4F6FB]' : 'hover:bg-[#F4F6FB]'}`}
        >
          {o.miniatura ? <img src={o.miniatura} alt="" className="h-8 w-8 shrink-0 rounded-lg object-cover" /> : <IconoSinMiniatura kind={o.kind} />}
          <span className="min-w-0 flex-1 truncate text-[14px] font-medium text-brand-black">{o.nombre}</span>
          <span className="shrink-0 rounded-full bg-[#02062B]/[0.05] py-0.5 px-2 text-[11px] font-medium text-[#02062B]/[0.45]">{o.etiqueta}</span>
        </button>
      ))}
    </div>
  </div>
);
